import React from 'react'

const ClientRisk = () => {
  return (
    <div></div>
  )
}

export default ClientRisk